import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  setBodyGradient,
  setBorderRadius,
  setBorderStroke,
  setBoxLayout,
  setIconColor,
  setMonoChrome,
  setThemeColor,
} from "../../Redux/actions/settingsActions";

const CommonSetting = ({ selectedMode }) => {
  const dispatch = useDispatch();

  const [theme, setTheme] = useState("Bluelight");
  const [borderStroke, setBorderStrok] = useState("svgstroke-a");
  const [boxLayout, setBoxLayoutt] = useState("");
  const [monochrome, setMonoChrom] = useState("");
  const [borderRadius, setBorderRadiuss] = useState("");
  const [iconColor, setIconColorr] = useState("");
  const [gradientColor, setGradientColor] = useState("");

  const ValenciaRed = theme === "ValenciaRed";
  const SunOrange = theme === "SunOrange";
  const AppleGreen = theme === "AppleGreen";
  const CeruleanBlue = theme === "CeruleanBlue";
  const Mariner = theme === "Mariner";
  const PurpleHeart = theme === "PurpleHeart";
  const Bluelight = theme === "Bluelight";

  useEffect(() => {
    dispatch(setThemeColor(theme));
    dispatch(setBorderStroke(borderStroke));
    dispatch(setBoxLayout(boxLayout));
    dispatch(setMonoChrome(monochrome));
    dispatch(setBorderRadius(borderRadius));
    dispatch(setIconColor(iconColor));
    dispatch(setBodyGradient(gradientColor));
    setBoxLayoutt("")
  }, [
    theme,
    borderStroke,
    boxLayout,
    monochrome,
    borderRadius,
    iconColor,
    gradientColor,
    dispatch
  ]);

  const handleStrockChange = (e) => {
    setBorderStrok(e.target.value);
  };

  //More App Setting
  const toggleBodyGradient = () => {
    if (gradientColor === "bg-gradient" && selectedMode !== "dark") {
      setGradientColor("bg-body");
    } else {
      setGradientColor("bg-gradient");
    }
  };

  const toggleMonochrome = () => {
    if (monochrome === "") {
      setMonoChrom("monochrome");
    } else {
      setMonoChrom("");
    }
  };

  const toggleBorderRadius = () => {
    if (borderRadius === "") {
      setBorderRadiuss("radius-0");
    } else {
      setBorderRadiuss("");
    }
  };

  const toggleIconColor = () => {
    if (iconColor === "") {
      setIconColorr("icon-color");
    } else {
      setIconColorr("");
    }
  };

  const toggleCardShadow = () => {
    const elements = document.getElementsByClassName("card");
    const ele = document.getElementById("BoxShadow").checked;

    for (let i = 0; i < elements.length; i++) {
      if (ele) {
        elements[i].classList.add("shadow-active");
      } else {
        elements[i].classList.remove("shadow-active");
      }
    }
  };

  //Layout Section Ligh/Dark
  const toggleTheme = (elementId) => {
    const element = document.getElementById(elementId);

    if (element) {
      if (element.getAttribute("data-bs-theme") === "none") {
        element.setAttribute("data-bs-theme", "dark");
      } else {
        element.setAttribute("data-bs-theme", "none");
      }
    }
  };

  const toggleSidebarDark = () => {
    toggleTheme("sidebar");
  };

  const toggleHeaderDark = () => {
    toggleTheme("commonNav");
  };

  return (
    <div
      className="collapse panel-body text-dark"
      id="collapseExample"
      data-back-drop="true"
    >
      <div className="template_setting card card-body border-0 rounded-4 shadow mb-2 w-100">
        <div className="row">
          <div className="col-md-4 col-sm-6">
            <div className="mb-4">
              <h6>Set Theme Color</h6>
              <ul className="choose-skin list-unstyled mb-0 row row-cols-5 g-3">
                <li
                  className={`col ${ValenciaRed ? "active" : ""}`}
                  data-theme="ValenciaRed"
                  onClick={() => setTheme("ValenciaRed")}
                >
                  <div style={{ "--dashbanker-theme-color": "#d63b38" }}></div>
                </li>
                <li
                  data-theme="SunOrange"
                  className={` col ${SunOrange ? "active" : ""}`}
                  onClick={() => setTheme("SunOrange")}
                >
                  <div style={{ "--dashbanker-theme-color": "#f7a614" }}></div>
                </li>
                <li
                  className={`${AppleGreen ? "active" : ""}`}
                  onClick={() => setTheme("AppleGreen")}
                  data-theme="AppleGreen"
                >
                  <div style={{ "--dashbanker-theme-color": "#5bc43a" }}></div>
                </li>
                <li
                  className={`${CeruleanBlue ? "active" : ""}`}
                  onClick={() => setTheme("CeruleanBlue")}
                  data-theme="CeruleanBlue"
                >
                  <div style={{ "--dashbanker-theme-color": "#00b8d6" }}></div>
                </li>
                <li
                  className={`${Mariner ? "active" : ""}`}
                  onClick={() => setTheme("Mariner")}
                  data-theme="Mariner"
                >
                  <div style={{ "--dashbanker-theme-color": "#0066fe" }}></div>
                </li>
                <li
                  className={`${PurpleHeart ? "active" : ""}`}
                  onClick={() => setTheme("PurpleHeart")}
                  data-theme="PurpleHeart"
                >
                  <div style={{ "--dashbanker-theme-color": "#6238b3" }}></div>
                </li>
                <li
                  className={`${Bluelight ? "active" : ""}`}
                  onClick={() => setTheme("Bluelight")}
                  data-theme="Bluelight"
                >
                  <div style={{ "--dashbanker-theme-color": "#1814F3" }}></div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-4 col-sm-6">
            <div className="svg-stroke mb-4">
              <h6>Icon Border Stroke</h6>
              <div
                className="btn-group"
                role="group"
                aria-label="Basic radio toggle button group"
              >
                <input
                  checked={borderStroke === "svgstroke-a"}
                  onChange={handleStrockChange}
                  type="radio"
                  className="btn-check"
                  name="stroke"
                  id="Stroke_A"
                  value="svgstroke-a"
                />
                <label className="btn btn-outline-primary" htmlFor="Stroke_A">
                  Stroke 1
                </label>

                <input
                  checked={borderStroke === "svgstroke-b"}
                  onChange={handleStrockChange}
                  type="radio"
                  className="btn-check"
                  name="stroke"
                  id="Stroke_B"
                  value="svgstroke-b"
                />
                <label className="btn btn-outline-primary" htmlFor="Stroke_B">
                  Stroke 2
                </label>

                <input
                  checked={borderStroke === "svgstroke-c"}
                  onChange={handleStrockChange}
                  type="radio"
                  className="btn-check"
                  name="stroke"
                  id="Stroke_C"
                  value="svgstroke-c"
                />
                <label className="btn btn-outline-primary" htmlFor="Stroke_C">
                  Stroke 3
                </label>
              </div>
            </div>
            <div className="mb-4">
              <h6>Layout Section Ligh/Dark</h6>
              <ul className="list-unstyled d-flex flex-wrap">
                <li className="me-2 mb-2 sidebar-toggle">
                  <input
                    type="checkbox"
                    className="btn-check"
                    id="Sidebar_dark"
                    onClick={toggleSidebarDark}
                  />
                  <label className="btn btn-outline-primary" htmlFor="Sidebar_dark">
                    Sidebar
                  </label>
                </li>
                <li className="me-2 mb-2 header-toggle">
                  <input
                    type="checkbox"
                    className="btn-check"
                    id="Header_dark"
                    onClick={toggleHeaderDark}
                  />
                  <label className="btn btn-outline-primary" htmlFor="Header_dark">
                    Header
                  </label>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-4 col-sm-6">
            <div className="mb-4">
              <h6>More App Setting</h6>
              <div className="form-check form-switch bodygradient-toggle">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="bodyGradient"
                  onClick={toggleBodyGradient}
                />
                <label className="form-check-label" htmlFor="bodyGradient">
                  Body Gradient Background
                </label>
              </div>

              <div className="form-check form-switch monochrome-toggle">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="monochrome"
                  onClick={toggleMonochrome}
                />
                <label className="form-check-label" htmlFor="monochrome">
                  Monochrome Mode
                </label>
              </div>
              <div className="form-check form-switch radius-toggle">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="radius0"
                  onClick={toggleBorderRadius}
                />
                <label className="form-check-label" htmlFor="radius0">
                  Border Radius none
                </label>
              </div>
              <div className="form-check form-switch svg-icon-color">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="IconColor"
                  onClick={toggleIconColor}
                />
                <label className="form-check-label" htmlFor="IconColor">
                  Sidebar Icon color
                </label>
              </div>
              <div className="form-check form-switch cb-shadow">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="BoxShadow"
                  onClick={toggleCardShadow}
                />
                <label className="form-check-label" htmlFor="BoxShadow">
                  Card box shadow active
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonSetting;
